import { SearchEbookField } from './SearchEbookField'
import { withSearchEbookField } from './withSearchEbookField'

const ConnectedSearchEbookField = withSearchEbookField(SearchEbookField)

export { ConnectedSearchEbookField as SearchEbookField }
